import {
  apiClient,
  Auth,
  Pagination,
  PaginationSearchParams,
} from '@/shared/api'

import { TInquiry } from '../model/schema'

export const getInquiries = async (params: PaginationSearchParams) => {
  const { data } = await apiClient.get<Pagination<TInquiry>>({
    endpoint: `/support/inquiries`,
    auth: Auth.REQUIRED,
    queryParams: {
      ...params,
      size: params.size ?? 20,
    },
  })

  return data
}
